import * as TypeGraphQL from "type-graphql";
export var AccountLinkingStatus;
(function (AccountLinkingStatus) {
    AccountLinkingStatus["PENDING"] = "PENDING";
    AccountLinkingStatus["EMAIL_SENT"] = "EMAIL_SENT";
    AccountLinkingStatus["VERIFIED"] = "VERIFIED";
    AccountLinkingStatus["APPROVED"] = "APPROVED";
    AccountLinkingStatus["REJECTED"] = "REJECTED";
    AccountLinkingStatus["EXPIRED"] = "EXPIRED";
})(AccountLinkingStatus || (AccountLinkingStatus = {}));
TypeGraphQL.registerEnumType(AccountLinkingStatus, {
    name: "AccountLinkingStatus",
    description: undefined,
});
//# sourceMappingURL=AccountLinkingStatus.js.map